'use strict';

var Params = function Params(containerWidth, containerHeight, zoomScaleExtent) {
  var padding = {
    top: 20,
    bottom: 50,
    left: 85,
    right: 85
  };
  var width = containerWidth - (padding.left + padding.right);
  var height = containerHeight - (padding.top + padding.bottom);
  return {
    zoomScaleExtent: zoomScaleExtent,
    width: width,
    height: height,
    containerWidth: containerWidth,
    containerHeight: containerHeight,
    padding: padding,
    xNumberOfTicks: 40,
    yNumberOfTicks: 5,
    yAxisShift: 0,
    xAxisLabelShift: 45,
    yAxisLabelShift: 40
  };
};
module.exports = Params;